(function () {
  'use strict';

  angular
    .module('app.product.customization', [])

    .component('customization', {
      require: {
        productCtrl: '^^productDetail'
      },
      bindings: {
        model: '<',
        tooltip: '@'
      },
      /* @ngInject */
      templateUrl: ["$sce", function ($sce) {
        return $sce.trustAsResourceUrl('/Template/Product/ProductCustomization');
      }],
      /* @ngInject */
      controller: ["$element", "LoadService", function ($element, LoadService) {
        var ctrl = this;

        ctrl.$onInit = function () {
          ctrl.js = ctrl.productCtrl.js;
          LoadService.getService('AsyncProductService', { ctrl: ctrl, element: $element }, 'initCustomization');
        };
      }]
    });

})();
